import React, { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const Register = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    businessName: '',
    businessType: '飲食店'
  });
  
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // パスワード確認チェック
    if (formData.password !== formData.confirmPassword) {
      setError('パスワードが一致しません');
      return;
    }
    
    setLoading(true);
    setError('');
    
    try {
      // 実際のAPIが実装されるまでダミー処理
      setTimeout(() => {
        // ダミーユーザー情報
        const userData = {
          id: Math.floor(Math.random() * 1000),
          email: formData.email,
          businessName: formData.businessName,
          businessType: formData.businessType
        };
        const token = 'dummy-token-' + Math.random().toString(36).substring(2, 15);
        
        login(userData, token);
        navigate('/');
      }, 1000);
      
      // 実際のAPI実装時はこちらを使用
      // const response = await fetch('/api/auth/register', {
      //   method: 'POST',
      //   headers: {
      //     'Content-Type': 'application/json'
      //   },
      //   body: JSON.stringify({
      //     email: formData.email,
      //     password: formData.password,
      //     businessName: formData.businessName,
      //     businessType: formData.businessType
      //   })
      // });
      // 
      // if (!response.ok) {
      //   const errorData = await response.json();
      //   throw new Error(errorData.message || '登録に失敗しました');
      // }
      // 
      // const data = await response.json();
      // login(data.user, data.token);
      // navigate('/');
    } catch (error) {
      setError(error.message || '登録に失敗しました。もう一度お試しください。');
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>AI職人くん</h1>
          <p>店舗SNS投稿作成サービス</p>
        </div>
        
        <h2>新規会員登録</h2>
        
        {error && <div className="error-message">{error}</div>}
        
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">メールアドレス</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="form-control"
              placeholder="example@example.com"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">パスワード</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              className="form-control"
              placeholder="8文字以上の英数字"
              minLength="8"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="confirmPassword">パスワード（確認）</label>
            <input
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
              className="form-control"
              placeholder="パスワードを再入力"
              minLength="8"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="businessName">店舗名</label>
            <input
              type="text"
              id="businessName"
              name="businessName"
              value={formData.businessName}
              onChange={handleChange}
              required
              className="form-control"
              placeholder="例: カフェAI"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="businessType">業種</label>
            <select
              id="businessType"
              name="businessType"
              value={formData.businessType}
              onChange={handleChange}
              required
              className="form-control"
            >
              <option value="飲食店">飲食店</option>
              <option value="美容室">美容室</option>
              <option value="小売店">小売店</option>
              <option value="その他">その他</option>
            </select>
          </div>
          
          <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
            {loading ? '登録中...' : '登録する'}
          </button>
        </form>
        
        <div className="auth-footer">
          <p>すでにアカウントをお持ちの方は <Link to="/login">ログイン</Link></p>
        </div>
      </div>
    </div>
  );
};

export default Register;
